import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1e897dea"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "padding-top": "18px",
    "padding-left": "30px"
  },
  src: "/assets/icon/upi.png",
  alt: ""
})], -1));

const _hoisted_3 = {
  class: "van-doc-card"
};
const _hoisted_4 = {
  class: "content"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Confirm Payment", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  style: {
    "border-top": "1px solid #5728a8"
  }
}, null, -1));

const _hoisted_7 = {
  class: "form-group"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Order ID", -1));

const _hoisted_9 = ["value"];
const _hoisted_10 = {
  class: "form-group"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red"
  }
}, "If payment is successful, please enter UTR")], -1));

const _hoisted_12 = /*#__PURE__*/_createTextVNode("Proceed");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("Back opt to pay");

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notes"
}, [/*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-align": "justify",
    "color": "brown"
  }
}, " If the payment fails, please click the back button and re-select the payment method."), /*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-align": "justify",
    "color": "brown"
  }
}, " Warning: Please fill in the UTR number correctly, if you do not fill in your recharge will not be able to get into the account.")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("input", {
    type: "text",
    class: "form-control",
    value: _ctx.$store.state.orderinfo.merchant_orderno,
    disabled: ""
  }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _withDirectives(_createElementVNode("input", {
    type: "number",
    class: "form-control",
    oninput: "if(value.length > 12) value = value.slice(0, 12)",
    onkeypress: "return( /[\\d]/.test(String.fromCharCode(event.keyCode)))",
    placeholder: "12 Digit UTR",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.utrvalue = $event)
  }, null, 512), [[_vModelText, $data.utrvalue]])])]), _createVNode(_component_van_button, {
    class: "cofbutton",
    onClick: $options.submitutr,
    disabled: $data.disabled
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }, 8, ["onClick", "disabled"])]), _createVNode(_component_van_button, {
    style: {
      "background-color": "#28a8a0"
    },
    class: "cofbutton",
    onClick: $options.backbutton,
    disabled: $data.disabled
  }, {
    default: _withCtx(() => [_hoisted_13]),
    _: 1
  }, 8, ["onClick", "disabled"]), _hoisted_14]);
}